








































import {Component, Mixins} from 'vue-property-decorator';
import {
    CaseWhoart, CaseWhoartRetrieveResponse, CommonModelUtils, WhoartSelectDialogRequest, TableHeader
} from '@/model/CommonModel';
import CommonPaginatedTable from '@/components/table/CommonPaginatedTable.vue';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import CommonButton from '@/components/button/CommonButton.vue';
import IconButton from '@/components/button/IconButton.vue';
import DefaultPaginateMixin from '@/views/DefaultPaginateMixin';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import TextInput from '@/components/input/TextInput.vue';
import SelectDialogMixin from '@/components/dialog/SelectDialogMixin';
import CaseApi from '@/api/CaseApi';
import MessageUtils from '@/utils/MessageUtils';

@Component({
    components: {TextInput, CommonPromptDialog, CommonPaginatedTable, CommonButton, IconButton},
    mixins: [DefaultPaginateMixin, DialogEventsMixin, SelectDialogMixin]
})
export default class CaseWhoartSelectDialog extends Mixins(DefaultPaginateMixin, DialogEventsMixin, SelectDialogMixin) {
    protected columns: TableHeader[] = [
        {
            columnId: 'inclTerm',
            columnLabel: this.$root.$t('message.case.whoart.inclTerm').toString(),
            filtered: 'N',
            visible: 'Y'
        },
        {
            columnId: 'termEng',
            columnLabel: this.$root.$t('message.case.whoart.termEng').toString(),
            filtered: 'N',
            visible: 'Y'
        },
        {
            columnId: 'arrn',
            columnLabel: this.$root.$t('message.case.whoart.arrn').toString(),
            filtered: 'N',
            visible: 'Y'
        },
        {
            columnId: 'seq',
            columnLabel: this.$root.$t('message.case.whoart.seq').toString(),
            filtered: 'N',
            visible: 'Y'
        },
        {
            columnId: 'subSeq',
            columnLabel: this.$root.$t('message.case.whoart.subSeq').toString(),
            filtered: 'N',
            visible: 'Y'
        }
    ];

    private version: string = '';
    private values: CaseWhoart[] = [];
    private onSelect: (row: CaseWhoart) => void;
    private onCancel: (keyword: string) => void;

    get isLoading() {
        return this.loading;
    }

    get getValues() {
        return this.values;
    }
    
    public mounted() {
        this.$modal
            .getEventBus()
            .$on('whoartSelectDialog', (params: WhoartSelectDialogRequest) => {
                this.show(params);
            });

        this.$modal.getEventBus().$on('hideWhoartSelectDialog', () => this.close());
    }
    
    public show(request: WhoartSelectDialogRequest) {
        this.width = request.width ? request.width : this.DEFAULT_WIDTH;
        this.keyword = request.keyword;
        this.version = request.version;
        this.onSelect = request.onSelect;
        this.onCancel = request.onCancel;

        this.loading = false;
        this.visible = true;

        this.retrieve(1, 10);
    }
    
    public onRowClick(data: any) {
        const {row, $event} = data;
        
        if (this.onSelect) {
            this.onSelect(row);
        }

        this.close();
    }
    
    protected retrieve(pageNo: number, rowCount: number) {
        this.lastKeyword = this.keyword;

        if (!this.keyword) {
            this.values = [];
            return;
        }

        const params: any = {pageNo, rowCount, keyword: this.keyword};
        this.loading = true;
        return CaseApi.retrieveWhoartCodes(this.version, params)
                      .then((res: CaseWhoartRetrieveResponse) => {
                          if (!res.success) {
                              return Promise.reject(res.errMsg);
                          }

                          const paginate = CommonModelUtils.getOrDefaultPaginate(res.data);
                          this.values = paginate.listInfo;
                          this.pageInfo = paginate.pageInfo;
                      })
                      .catch((errMsg) => this.afterRequestFail(errMsg))
                      .finally(() => this.loading = false);
    }

    public close() {
        if (this.onCancel) {
            this.onCancel(this.lastKeyword);
        }

        this.visible = false;
    }

    public afterClosed() {
        this.values = [];
        this.keyword = '';
        this.lastKeyword = '';
        this.loading = false;
    }

    public destroyed() {
        this.$modal.getEventBus().$off('whoartSelectDialog');
        this.$modal.getEventBus().$off('hideWhoartSelectDialog');
    }
}
